import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import languagesImg from "./languages.png"
import { NamedLink, IconCheckMarkAssets, Button } from '../../../components';

import css from './SectionAllCourseTeaching.module.css';
import classNames from 'classnames';
import { getBullets } from '../../../util/contentful';
import { getLetterType } from '../../../util/lettersHelper';

const SectionAllCourseTeaching = props => {
  const { currentUser, handleGetStarted, isTeacher, currentState, currentSubject, content } = props;

  const items = content && getBullets(content, 'allCourseTeachingBullet');

  let article = 'a';
  if(currentState) {
    const firstLetterOfCurrentSubject = currentState?.label?.substring(0, 1).toLowerCase();
    const letterTypeObject = getLetterType(firstLetterOfCurrentSubject);
    const letterType = letterTypeObject.type;
    article = letterType === 'vowel' ? 'an' : 'a';
  }

  return (
    <div className={css.root}>
      {content ? (
        <div className={css.contentContainer}>
          <div className={css.info}>
            <h1 className={css.title}>
              {content?.allCourseTeachingTitle}546543212
            </h1>
            <ul className={css.list}>
              {Array.from(Array(Object.keys(items).length).keys()).map(i => (
                <li className={classNames(css.listItem, css.listItemBold)}>
                  <IconCheckMarkAssets />
                  {items[`allCourseTeachingBullet${i + 1}Title`]}
                </li>
              ))}
            </ul>

            {!currentUser && (
              <div className={css.emailContainer}>
                <Button className={css.button} onClick={handleGetStarted}>
                  <FormattedMessage id="SectionHero.signUpJoinBtn" />
                </Button>
              </div>
            )}
            {currentUser && isTeacher && (
              <div className={css.createCourseContainer}>
                <NamedLink
                  name="NewListingPage"
                  className={css.button}
                >
                  {!currentState ? <FormattedMessage id='SectionHero.createCourseBtn' />
                    : <FormattedMessage id="SectionHero.signUpJoinBtn" />}
                </NamedLink>
              </div>
            )}

          </div>
          <div className={css.imageContainer}>
            <img src={languagesImg} className={css.image} />
          </div>

        </div>
      ) : (
        <div className={css.contentContainer}>
          <div className={css.info}>
            <h2 className={css.title}>
              {currentState && !currentSubject ?
                <FormattedMessage id='SectionAllCourseTeaching.stateTitle' values={{state: currentState?.label}} /> :
                currentState && currentSubject ?
                <FormattedMessage id='SectionAllCourseTeaching.subjectTitle' values={{state: currentState?.label, subject: currentSubject?.parent}} /> :
                <FormattedMessage id='SectionAllCourseTeaching.title' />

              }
            </h2>
            <ul className={css.list}>
              <li className={css.listItem}>
                <IconCheckMarkAssets />
                {currentState ? <FormattedMessage id='SectionAllCourseTeaching.stateListItem1' values={{state: currentState?.label, article}} /> :
                  <FormattedMessage id='SectionAllCourseTeaching.listItem1' />
                }
              </li>
              <li className={css.listItem}>
                <IconCheckMarkAssets />
                <FormattedMessage id='SectionAllCourseTeaching.listItem2' />
              </li>
              <li className={css.listItem}>
                <IconCheckMarkAssets />
                <FormattedMessage id='SectionAllCourseTeaching.listItem3' />
              </li>
            </ul>

            {!currentUser && (
              <div className={css.emailContainer}>
                <Button className={css.button} onClick={handleGetStarted}>
                  <FormattedMessage id="SectionHero.signUpJoinBtn" />
                </Button>
              </div>
            )}
            {currentUser && isTeacher && (
              <div className={css.createCourseContainer}>
                <NamedLink
                  name="NewListingPage"
                  className={css.button}
                >
                  {!currentState ? <FormattedMessage id='SectionHero.createCourseBtn' />
                    : <FormattedMessage id="SectionHero.signUpJoinBtn" />}
                </NamedLink>
              </div>
            )}

          </div>
          <div className={css.imageContainer}>
            <img src={languagesImg} className={css.image} />
          </div>

        </div>
      )}
    </div>
  )
}

export default SectionAllCourseTeaching;
